<template>
  <div v-loading="loading">
    <div class="fx mt-20 mb-20">
      <el-input v-model="listQuery.keyword" placeholder="请输入查询关键词" style="width:200px" clearable />
      <el-select v-model="listQuery.taskStatus" placeholder="请选择抓取状态" class="ml-16" clearable>
        <el-option v-for="(item,index) in options" :label="item.label" :value="item.value" :key="index"></el-option>
      </el-select>
      <el-button type="primary" class="ml-16" @click="reqAccountCustomerPage">查询</el-button>
      <el-button type="primary" class="ml-16" @click="importantKeyword" >导入关键词</el-button>
    </div>
    <el-table border :data="tableData" stripe  max-height="700">
      <el-table-column prop="keyword" label="关键词"></el-table-column>
      <el-table-column prop="taskStatus" label="抓取状态">
        <template slot-scope="scope">{{statusTxt(scope.row.taskStatus)}}</template>
      </el-table-column>
      <el-table-column prop="totalUsers" label="总用户量"></el-table-column>
      <el-table-column prop="totalActiveUsers" label="有效用户量"></el-table-column>
      <el-table-column prop="taskCreateDate" label="开始时间"></el-table-column>
      <el-table-column prop="endTime" label="结束时间"></el-table-column>
    </el-table>
    <el-dialog title="导入关键词" :visible.sync="KeywordShow" class="el-dialog-5235" custom-class="" :before-close="handleClose" width="448px" height="394px">
      <div class="dialog-main">
        <p class="title">1.请按照模板格式准备需要导入的数据</p>
        <p class="text fx-s-center">
          <a class="fx-none" href="./excel/wa关键字导入.xlsx" download><i class="wm wm-xiazai"></i> <span>下载关键词导入模板</span></a>
          <span class="fx-full"></span>
        </p>
        <p class="title mt-24">2.请选择需要导入的文件</p>
        <div class="">
          <p class="text fx-s-center">
            <a class="fx-none" href="javascript:void(0);" @click="clickUpload">
              <i class="wm wm-shangchuan"></i> <span>上传文件</span>
            </a>
            <span class="fx-full"></span>
          </p>
          <p v-if="file.name" class="file fx-s-center  fx">
            <text-overflow class="fx-full">{{ file.name }}</text-overflow><span style="width: 14px;"></span><i class="fx-none el-icon-error " @click="closeUpload()"></i>
          </p>
        </div>
      </div>
      <div slot="footer" class="button fx">
        <div class="fx-full"></div>
        <el-button type="" plain @click="closeUpload(1)">取消</el-button>
        <el-button style="margin-left: 16px;" type="primary"  @click="clickImport()" :loading="keyWordLoading">导入</el-button>
      </div>
    </el-dialog>
    <el-pagination class="mt-16" :total="total" :current-page="listQuery.pageNum" :page-size="listQuery.pageSize" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50]"
      @size-change="handleSizePageChange" @current-change="handlePageChange"></el-pagination>
  </div>
</template>

<script>
import textOverflow from '@/components/textOverflow'
import { accountCustomerPage, uploadWordExtended } from '@/api/data'
export default {
  components: {
    textOverflow
  },
  data() {
    return {
      tableData: [],
      listQuery: {
        keyword: '',
        taskStatus: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      KeywordShow: false,
      options: [
        { value: '1', label: '未开始' },
        { value: '2', label: '进行中' },
        { value: '3', label: '已完成' },
        { value: '4', label: '未完成' }
      ],
      file: {},
      loading: false,
      keyWordLoading: false
    }
  },
  computed: {
    statusTxt() {
      return item => this.options.filter(v => v.value == item)[0].label
    }
  },
  created() {
    this.reqAccountCustomerPage()
  },
  methods: {
    reqAccountCustomerPage() {
      this.loading = true
      accountCustomerPage(this.listQuery).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },
    handleSizePageChange(val) {
      this.listQuery.pageSize = val
      this.reqAccountCustomerPage()
    },
    handlePageChange(val) {
      this.listQuery.pageNum = val
      this.reqAccountCustomerPage()
    },
    handleClose() {
      this.KeywordShow = false
    },
    closeUpload(type) {
      this.file = { name: '' }
      if (type === 1) {
        this.KeywordShow = false
        this.handleClose()
      }
    },
    clickUpload() {
      var input = document.createElement('input')
      input.type = 'file'
      input.accept = '.xlsx,.xls'
      input.id = '_select-file'
      input.style.display = 'none'
      input.click()
      var self = this
      input.onchange = function(e) {
        self.file = e.target.files[0]
      }
    },
    clickImport() {
      if (this.file.name === '') {
        this.$message.warning('请选择文件')
        return
      }
      this.keyWordLoading = true
      const data = new FormData()
      data.append('file', this.file)
      data.append('test', true)
      uploadWordExtended(data).then(res => {
        if (res.code == 200) {
          this.KeywordShow = false
          this.reqAccountCustomerPage()
          this.$message.success('导入成功')
          this.keyWordLoading = false
        } else {
          this.$message.error(res.message)
        }
      }).catch().finally(() => { this.keyWordLoading = false })
    },
    importantKeyword() {
      this.KeywordShow = true
      this.file = { name: '' }
    }
  }
}
</script>

<style lang="scss" scoped>
.ml-16 {
  margin-left: 16px;
}
.mt-16 {
  margin-top: 16px;
  text-align: right;
}
</style>
